/**
 * Header Megamenu: Handles desktop megamenu interactions and mobile menu toggles
 * Manages menu item activation, panel display, and sticky header state
 */

/**
 * Setup megamenu panel switching for a set of menu items and panels
 * @param {NodeList} items - Menu item elements
 * @param {NodeList} panels - Panel elements to display
 */
function setupMenu(items, panels) {
  items.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      const target = item.dataset.panel;

      // Reset specific lists
      items.forEach((i) => i.classList.remove('active'));
      panels.forEach((p) => p.classList.remove('active'));

      // Activate targets
      item.classList.add('active');
      const targetEl = document.getElementById(target);
      if (targetEl) targetEl.classList.add('active');
    });
  });
}

/**
 * Initialize desktop megamenus (all 3 menu items)
 */
function initDesktopMenus() {
  // Menu set 1
  const menuItems1 = document.querySelectorAll('.menu-item--1');
  const panels1 = document.querySelectorAll('.menu-panel--1');
  setupMenu(menuItems1, panels1);

  // Menu set 2
  const menuItems2 = document.querySelectorAll('.menu-item--2');
  const panels2 = document.querySelectorAll('.menu-panel--2');
  setupMenu(menuItems2, panels2);

  // Menu set 3
  const menuItems3 = document.querySelectorAll('.menu-item--3');
  const panels3 = document.querySelectorAll('.menu-panel--3');
  setupMenu(menuItems3, panels3);
}

/**
 * Initialize mobile menu toggle with proper scroll handling and positioning
 */
function initMobileMenu() {
  const mobileMenuOpener = document.querySelector('.mobile-menu-opener');
  const body = document.body;
  const html = document.documentElement;
  const mobileMenu = document.querySelector('.main-nav--mobile');

  if (!mobileMenuOpener) return;

  mobileMenuOpener.addEventListener('click', () => {
    const isOpening = !body.classList.contains('menu-open');
    const header = document.querySelector('header');

    if (isOpening) {      
      const scrollY = window.scrollY;
      const headerRect = header.getBoundingClientRect();
      const headerBottom = headerRect.bottom;

      mobileMenu.style.top = `${headerBottom}px`;
      mobileMenu.style.height = `calc(100dvh - ${headerBottom}px)`;

      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.width = '100%';

      body.classList.add('menu-open');
      mobileMenuOpener.classList.add('open');
      mobileMenu.classList.add('open');
    } else {      
      // Reset styles when closing
      mobileMenu.style.top = '';
      mobileMenu.style.height = '';

      const scrollY = body.style.top;
      html.style.scrollBehavior = 'auto';
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      html.style.scrollBehavior = '';
      body.classList.remove('menu-open');
      mobileMenuOpener.classList.remove('open');
      mobileMenu.classList.remove('open');
    }
  });
}

/**
 * Initialize mobile menu accordion sections with jQuery slideToggle
 */
function initMobileAccordions() {
  $('.nav-item-head').on('click', function () {
    $(this).siblings('.nav-item-dropdown').slideToggle(300);
    $(this).parent().toggleClass('active');
    $('.nav-item-head').not(this).siblings('.nav-item-dropdown').slideUp(300);
    $('.nav-item-head').not(this).parent().removeClass('active');
  });

  $('.dropdown-item__header').on('click', function () {
    $(this).siblings('.dropdown-item__body').slideToggle(300);
    $(this).toggleClass('active');
    $('.dropdown-item__header').not(this).siblings('.dropdown-item__body').slideUp(300);
    $('.dropdown-item__header').not(this).removeClass('active');
  });
}

/**
 * Initialize sticky header state detection using IntersectionObserver
 * Watches announcement bar and applies 'is-sticky' class when header leaves viewport
 */
function initStickyHeader() {
  const header = document.querySelector('header');
  const sentinel = document.querySelector('#shopify-section-announcement-bar');

  if (!header) return;

  let ticking = false;

  const updateHeaderOffset = () => {
    const headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--header-bottom-position', `${headerBottom}px`);
    ticking = false;
  };

  const requestHeaderOffsetUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeaderOffset);
  };

  updateHeaderOffset();
  window.addEventListener('resize', requestHeaderOffsetUpdate);
  window.addEventListener('scroll', requestHeaderOffsetUpdate, { passive: true });

  if (!sentinel) return;

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries[0].isIntersecting) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }

      requestHeaderOffsetUpdate();
    },
    {
      threshold: [0],
      rootMargin: '-30px 0px 0px 0px',
    }
  );

  observer.observe(sentinel);
}


const storiesNav = document.querySelector('.homepage-stories-navigation__inner');

function updateMask() {
  if (!storiesNav) return;

  const maxScroll = storiesNav.scrollWidth - storiesNav.clientWidth;

  if (maxScroll <= 0) {
    storiesNav.style.setProperty('--left-fade', '0%');
    storiesNav.style.setProperty('--right-fade', '100%');
    return;
  }

  const left = storiesNav.scrollLeft > 2 ? '8%' : '0%';
  const right = storiesNav.scrollLeft < maxScroll - 2 ? '92%' : '100%';

  storiesNav.style.setProperty('--left-fade', left);
  storiesNav.style.setProperty('--right-fade', right);
}

if (storiesNav) {
  storiesNav.addEventListener('scroll', updateMask);
  window.addEventListener('resize', updateMask);
}


/**
 * Initialize all header functionality
 */
function initHeader() {
  initDesktopMenus();
  initMobileMenu();
  initMobileAccordions();
  initStickyHeader();
  updateMask();
}

export default initHeader;
